import awsExports from '../aws-exports';

/**
 * `public/capacity.json` in the media bucket — a coarse, sweep-written-daily snapshot of
 * free-tier signup availability (Q11/§6, docs/plans/2026-07-29-free-tier-cap-enforcement.md):
 * `{ freeSlotsAvailable: bool, waitlistLengthApprox: <nearest 5> }`. Deliberately a plain public
 * S3 object, not a Lambda-backed endpoint — no Amplify API call, no auth, just fetch().
 *
 * May be up to 24h stale, so callers must hedge the copy ("usually available" / "currently
 * full") rather than presenting it as a live count, and must render nothing on failure (never a
 * broken-looking gap or a stale spinner) — this function returns null for any failure, including
 * a malformed body.
 *
 * Bucket name/region come from aws-exports.js (Amplify-generated per env), so this resolves to
 * whichever env's bucket the app was built against — no hardcoded dev/prod URL.
 */
const CAPACITY_URL =
  `https://${awsExports.aws_user_files_s3_bucket}.s3.${awsExports.aws_user_files_s3_bucket_region}.amazonaws.com/public/capacity.json`;

export async function getCapacitySnapshot() {
  try {
    const response = await fetch(CAPACITY_URL, { cache: 'no-store' });
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    if (typeof data?.freeSlotsAvailable !== 'boolean') {
      return null;
    }
    return data;
  } catch (error) {
    console.error('capacityService: failed to fetch capacity.json', error);
    return null;
  }
}

const capacityService = { getCapacitySnapshot };
export default capacityService;
